import formik, {Field} from 'formik';
import moment from 'moment';
import React, {createRef, ReactElement, useEffect} from 'react';
import Rolldate from 'rolldate-full';

const _pickerId = 'datepicker_sam_0';

type BuddyDatePickerProps = {
  dateFormat: string;
  onDateSelected: (value: Date) => void;
  onCancelPressed: () => void;
  startYear?: number;
  endYear?: number;
  initialValue?: Date;
};

const BuddyDatePicker: React.FC<BuddyDatePickerProps> = ({
  dateFormat,
  startYear,
  endYear,
  initialValue,
  onDateSelected,
  onCancelPressed,
}: BuddyDatePickerProps): ReactElement => {
  function _getStartYear(): number {
    if (startYear && startYear > 0) {
      return startYear;
    }
    const _today = new Date();
    return _today.getFullYear() - 100;
  }

  const _fieldRef = createRef();

  const _roleDateInstance = new Rolldate({
    lang: {
      title: 'Pick a date',
      cancel: 'Cancel',
      confirm: 'Confirm',
      year: '',
      month: '',
      day: '',
    },
    cancel: () => {
      console.log('cancel click');
      onCancelPressed();
    },

    format: dateFormat,
    beginYear: _getStartYear(),
    endYear: endYear || new Date().getFullYear(),
    value: initialValue ? moment(initialValue).format('YYYY-MM-DD') : '',
    confirm: (date: string) => {
      (document.getElementById(_pickerId) as any).value = date;
      console.log(onDateSelected);
      console.log(date);

      onDateSelected(moment(date, dateFormat || 'DD/MM/YYYY').toDate());
    },
  });

  return (
    <input
      id={_pickerId}
      name="dateOfBirth"
      placeholder={'DD/MM/YYYY'}
      onFocus={() => {
        _roleDateInstance.show();
      }}
      readOnly={true}
      value={initialValue && initialValue instanceof Date ? isNaN(initialValue.getDate()) ? '' : moment(initialValue).format('DD/MM/YYYY') : ''}
      className="w-5/6 text-sm focus:outline-none place-items-center ml-2.5 -mt-2.5 bg-transparent"
    />
  );
};

export default BuddyDatePicker;
